import React, { useState } from 'react';
import ContentWrapper from '../components/ContentWrapper';
import SoppelSorteringImage from'../images/portfolio/HogskolenVolda/HeroImage.jpg';
import NRKVideo from'../images/portfolio/NRK/nrk_video.png';
import RotsetHornetImage from '../images/portfolio/Rotsethornet/HeroImage.jpg';
import Skolekinodagen from '../images/portfolio/FilmOgKino/video-thumbnail.jpg';
import FiletSkolenImage from '../images/portfolio/FiletSkolen/HeroImage.jpg';
import CreazaImage from '../images/portfolio/Creaza/HeroImage.jpg';
import AlphabetPlanetImage from '../images/portfolio/Creaza/AlfabetPlaneten/thumbnail.jpg';
import IPR from '../images/portfolio/IPR/tannpuss-2.png';
import Refinansiering from '../images/portfolio/Sparebank1/refinansiering.png';
import RoomOfMirrorsThumbnail from '../images/portfolio/Tristious/room-of-mirrors.png';
import LiteraryAnalysis from '../images/portfolio/NDLA/literary-analysis.png';
import JetRunner from '../images/portfolio/JetRunner/thumbnail.png';

import { LocalizedLink as Link, useT } from '../i18n';
import '../styles/portfolio.css';

const Work = () => {
    const t = useT();
    const clientProjects = [
      {
        image: LiteraryAnalysis,
        client: "Klipp og Lim",
        title: "NDLA",
        projectname: "ndla"
      },
      {
        image: JetRunner,
        client: "Riddlebit",
        title: "JETRUNNER",
        projectname: "jetrunner"
      },
      {
        image: RoomOfMirrorsThumbnail,
        client: "Tristious",
        title: "Metallica",
        projectname: "tristious"
      },
      {
        image: Refinansiering,
        client: "SpareBank 1",
        title: t("Refinansiering og forbrukslån", "Refinancing and consumer loans"),
        projectname: "sparebank-1"
      },
      {
        image: IPR,
        client: "IPR (WeMake)",
        title: t("Sinte barn og sinte voksne", "Angry children and angry adults"),
        projectname: "IPR"
      },
      {
        image: NRKVideo,
        client: "",
        title: "NRK" ,
        description: <div>
          {t(
            <p>“Andreas Wahl har alltid drømt om å få være vektløs som en astronaut. <br /> Nå har han fått sjansen til å forklare hvorfor vektløshet <br /> er det samme som å være i fritt fall.”</p>,
            <p>“Andreas Wahl has always dreamed of being weightless like an astronaut. <br /> Now he gets the chance to explain why weightlessness <br /> is the same as being in free fall.”</p>
          )}
        </div>,
        projectname: "nrk"
      },
      {
        image: AlphabetPlanetImage,
        client: "Creaza",
        title: t("Alfabetplaneten", "Alfabetplaneten (The Alphabet Planet)"),
        projectname: "alfabetplaneten"
      },
      {
        image: Skolekinodagen,
        client: "Film og Kino",
        title: t("Den Store Skolekinodagen", "Den Store Skolekinodagen (The Big School Cinema Day)"),
        projectname: "film-og-kino"
      },
      {
        image: CreazaImage,
        client: "Creaza",
        title: t("Kreative filmer for nettside", "Creative films for a learning website"),
        description: t("Vil du lære på en underholdende og kreativ måte?", "Want to learn in a fun and creative way?"),
        projectname: "creaza"
      },
      {
        image: RotsetHornetImage,
        client: "Oclin",
        title: "Rotsethornet",
        description: t("Få med deg hva Rotsethornet har å si!", "Hear what Rotsethornet has to say!"),
        projectname: "rotsethornet"
      },
      {
        image: FiletSkolenImage,
        client: "Cod Cluster",
        title: t("Filetskolen modul 2", "Filetskolen, module 2"),
        projectname: "filetskolen"
      },
      {
        image: SoppelSorteringImage,
        client: t("Høgskulen i Volda", "Volda University College"),
        title: t("Søppelsortering", "Waste sorting"),
        projectname: "hogskolenvolda"
      },
    ];

   

    return  <ContentWrapper>
        <div className="mb-8 mt-20">
        <p className="text-center text-3xl mb-4">{t('Tidligere oppdrag', 'Past projects')}</p>
        <div className="flex flex-wrap justify-center gap-3">
          
          {clientProjects.map((project) => {
            return <PortfolioProject
              image={project.image}
              client={project.client}
              title={project.title}
              description={project.description}
              projectname={project.projectname}
            /> 
          })}
        </div>
       
        </div>
        
      
      </ContentWrapper>

}

const PortfolioProject = ({ image, client, title, description, projectname}) => {
  const t = useT();
  return <Link to={`/portfolio/${projectname}`} className="">
    <div className="p-4 mb-4 max-w-md" >
    <div className="overflow-hidden rounded-t-md max-w-xs md:max-w-md max-h-64 md:h-64">
      <img className="max-w-xs md:max-w-md" src={image} />
    </div>

    <p className="mt-7">{client}</p>
    <p className="text-xl mt-1 mb-2">{title}</p>
    {description && <p className="mb-8 max-w-xs md:max-w-md">{description}</p>}
     <p className="underline text-tb-orange  cursor-pointer">{t('Les mer', 'Read more')}</p>
  </div></Link>
}



export default Work;


